import React from 'react';

export default () => (
  <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line
      y1="-0.5"
      x2="10.0902"
      y2="-0.5"
      transform="matrix(0.668965 -0.743294 0.668965 0.743294 1 15)"
      stroke="#1B1B1B"
    />
    <line
      y1="-0.5"
      x2="10.0902"
      y2="-0.5"
      transform="matrix(0.668965 0.743294 0.668965 -0.743294 1 0)"
      stroke="#1B1B1B"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/faqpage/components/icons/RightCaretIcon.tsx